<script lang="ts" setup>
  const scrollZone = useTemplateRef('scrollZone')

  onMounted(() => {
    scrollZone.value?.addEventListener('wheel', (e: WheelEvent) => {
      const target = e.currentTarget as HTMLElement
      if ((target.parentElement as HTMLElement).clientWidth < target.scrollWidth) {
        e.preventDefault()
        target.scroll({ left: target.scrollLeft + Math.sign(e.deltaY) * 100, behavior: 'auto' })
      }
    })
  })

</script>

<template>
  <div
    ref="scrollZone"
    class="c-scroll-h"
  >
    <slot />
  </div>
</template>
<style  scoped>
.c-scroll-h {
  position: relative;
  display: flex;
  flex: 1 0 auto;
  flex-direction: row;
  overflow-x: auto;
}
</style>
